import React, { FC } from 'react';
import { LawFirmPopoverInfos } from '../lawFirm.types';
import { LawFirmCardTitle } from '../card/LawFirmCardTitle';
import { EntitiesCardBody } from '../../components/entities-card/EntitiesCardBody';
import { LawFirmDetails } from './LawFirmDetails';
import { EntitiesList } from '../../components/entities-card/EntitiesList';
import { useRestrictedModal } from '../../components/modal/useRestrictedModal';
import { useUser } from '../../user/useUser';
import { Spacing } from '../../components/entities-card/Spacing';

type Props = {
  lawFirm: LawFirmPopoverInfos;
  source: string;
};

export const LawFirmCard: FC<Props> = ({ lawFirm, source }) => {
  const { accessPremium } = useUser();
  const { openRestrictedModal } = useRestrictedModal();

  const handleClick = (newSource: string) => () => {
    if (!accessPremium) {
      openRestrictedModal({ source: newSource });
    }
  };

  return (
    <>
      <EntitiesCardBody>
        <LawFirmCardTitle
          href={
            accessPremium ? `${lawFirm.url}?source=${source}-header` : undefined
          }
          onClick={handleClick(`${source}-header`)}
        >
          {lawFirm.name}
        </LawFirmCardTitle>
        <Spacing />
        <EntitiesList>
          <LawFirmDetails lawFirm={lawFirm} />
        </EntitiesList>
      </EntitiesCardBody>
    </>
  );
};
